import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Empresa } from '../model/empresa';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MotorService {

  public empresa = new BehaviorSubject<Empresa>(new Empresa());
  public tokenMotor = new BehaviorSubject<String>("");

  empresaObservable = this.empresa.asObservable();
  tokenMotorObservable = this.tokenMotor.asObservable();

  constructor(
      private readonly http: HttpClient
  ) {
      console.log("MotorService.constructor()");
  }

  changeEmpresa(empresa: Empresa): void {
    this.empresa.next(empresa);
  }

}